<template>
  <content-placeholders v-if="isLoading">
    <ul class="category-tree">
      <li v-for="num in 5" :key="num">
        <content-placeholders-text class="category-name-link" :lines="1" />
      </li>
    </ul>
  </content-placeholders>
  <ul v-else class="category-tree">
    <li v-for="category in categoryList" :key="category.identifier">
      <router-link
        class="category-name-link"
        :to="`/category/${category.identifier}?lang=${language}`"
      >
        <span>{{ category.name[language] }}</span>
        <span>
          {{
            category.subcategories ? `(${category.subcategories.length})` : ""
          }}
        </span>
      </router-link>
      <div
        v-if="
          routeIdentifier === category.identifier &&
          category.subcategories?.length
        "
        class="subcategory-container"
      >
        <ul>
          <li
            v-for="subcategory in category.subcategories"
            :key="subcategory.identifier"
          >
            <router-link
              class="category-name-link"
              :to="`/category/${subcategory.identifier}?lang=${language}`"
            >
              <span>
                {{ subcategory.name[language] }}
              </span>
            </router-link>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "CategoryNav",
  props: {
    language: {
      type: String,
      default: "en",
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {},
  computed: {
    categoryList() {
      return this.$store.getters.categoryTree;
    },
    routeIdentifier() {
      return this.$route.params.categoryIdentifier;
    },
  },
  mounted() {
    this.isLoading = true;
    this.$store.dispatch("fetchCategories").then(() => {
      this.isLoading = false;
    });
  },
};
</script>

<style>
.category-tree,
.subcategory-container > ul {
  list-style: none;
  padding-left: 0;
  position: relative;
  font-size: var(--small-text);
}

.subcategory-container {
  padding-left: 28px;
  overflow: hidden;
}

.category-tree .subcategory-container > ul > li:before {
  content: "";
  position: absolute;
  left: -14px;
  border: 0 solid transparent;
  border-left-width: 1px;
  border-bottom-width: 1px;
  border-color: #c7c7c7;
  width: 12px;
  height: 14px;
}

.category-tree .subcategory-container > ul > li:after {
  position: absolute;
  content: "";
  top: -27px;
  left: -14px;
  border: 0 solid transparent;
  border-left-width: 1px;
  border-color: #c7c7c7;
  height: 100%;
}

.category-name-link {
  text-decoration: none;
  display: flex;
  justify-content: space-between;
  color: var(--rofix-gray);
  padding: 5px;
  transition: background-color 0.15s;
}

.category-name-link:hover {
  background-color: var(--rofix-lighter-gray);
}
</style>
